import React from "react";

const WindPopup: React.FC<{
  isWind: boolean;
  wind: string;
  city: string;
}> = ({ isWind, wind, city }) => {
  return (
    <div className="bg-black/40 p-1.5 rounded-md -mb-12 flex flex-col items-center justify-center">
      <div>
        <span className="text-base font-bold">{wind}</span>
        <span className="text-sm ml-1">{isWind ? "м/с" : "°C"}</span>
      </div>
      <div className="text-sm">{city}</div>
    </div>
  );
};
export default WindPopup;
